import diabetes from '../images/Diabetes.jpg';
import fluidManagement from '../images/FluidManagement.jpg';
import bone from '../images/Bone.jpg';

export const SliderData = [
    {
        image: diabetes,
        link: "https://www.kdf.org.sg/resources/ck/files/Diabetes%20and%20Kidney%20Disease_FA.pdf"
    },
    {
        image: fluidManagement,
        link: "https://www.kdf.org.sg/resources/ck/files/FluidManagement.pdf"
    },
    {
        image: bone,
        link: "https://www.kdf.org.sg/resources/ck/files/BoneProblemsInEnd-StageRenalFailure.pdf"
    }
];
